import { render, staticRenderFns } from "./NewPartnerSiteRedirectModal.vue?vue&type=template&id=0ade4320&"
import script from "./NewPartnerSiteRedirectModal.vue?vue&type=script&lang=js&"
export * from "./NewPartnerSiteRedirectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports